import { render, staticRenderFns } from "./ContestOfferStatsEmpty.vue?vue&type=template&id=f28b2a58&scoped=true&"
import script from "./ContestOfferStatsEmpty.vue?vue&type=script&lang=js&"
export * from "./ContestOfferStatsEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28b2a58",
  null
  
)

export default component.exports